angular.module('iw.frontyard.signup')
    .service('SignupAPIHelper', function ($http) {

        var API_STATE_URL = '/api/customer/state/';
        var API_EMAIL_CHECKER_URL = '/api/customer/email_valid/';

        var httpOptions = {
            headers: {
                'xsrfCookieName': 'csrftoken',
                'xsrfHeaderName': 'X-CSRFToken'
            }
        };

        class SignupAPIHelper {
            constructor() {
            }

            serializeDataToSend(signupState) {
                var serialised = {
                    application: {
                        people: [{
                            uid: signupState.uid,
                            roles: ['applicant'],
                            email: signupState.email,
                            marketing_emails: signupState.marketingEmails
                        }],
                        loan_request: serializeLoanRequest(signupState),
                    }
                };

                return serialised;
            }

            generateUUID() {
                var datetime = new Date().getTime();
                var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
                    var random = (datetime + Math.random() * 16) % 16 | 0;
                    datetime = Math.floor(datetime / 16);
                    return (char === 'x' ? random : (random & 0x3 | 0x8)).toString(16);
                });
                return uid;
            }

            isValidEmail(email) {
                return $http.get(API_EMAIL_CHECKER_URL, {
                    params: {email: email},
                    cache: true
                }, httpOptions);
            }

            postData(data) {
                return $http.post(API_STATE_URL, data, httpOptions);
            }
        }
        function serializeLoanRequest(signupState) {
            switch (signupState.urgency) {
                case 1:
                    return {
                        urgency: 'future_use',
                        amount: signupState.requestedAmount
                    };
                case 2:
                    return {
                        urgency: 'weeks',
                        amount: signupState.requestedAmount,
                        purpose: signupState.reason,
                        detailed_reason: (signupState.reason === 'other' ? signupState.detailedReason : undefined),
                    };
                case 3:
                    return {
                        urgency: 'asap',
                        amount: signupState.requestedAmount,
                        purpose: signupState.reason,
                        detailed_reason: (signupState.reason === 'other' ? signupState.detailedReason : undefined),
                    };
                default:
                    return {};
            }
        }

        function serialiseUrgency(urgency) {
            switch (urgency) {
                case 1:
                    return 'future_use';
                case 2:
                    return 'weeks';
                case 3:
                    return 'asap';
            }
        }

        return new SignupAPIHelper();
    });